import React from 'react';

const BreadCrumbs = ({ children, className, ...rest }) => {
  let idx = 0;

  return (
    <div className={className ? className : null} {...rest}>
      {children.map((elem) => {
        if (!elem) {
          return '';
        }

        return idx++ === 0 ? (
          <span key={`breadcrumb_${idx}`}>{elem}</span>
        ) : (
          <span key={`breadcrumb_${idx}`}>
            <span className="ml mr">&gt;</span>
            {elem}
          </span>
        );
      })}
    </div>
  );
};

export default BreadCrumbs;
